<template>
  <div>
    <f-model :visible.sync="visible" :showclose="false" width="720px">
      <div class="info-contain v25" slot="body">
        <div class="info-bgceng"></div>
        <div class="aclose" @click="close">
          <i class="iconfont icon-fanbaiquxiao"></i>
        </div>
        <div class="info-top" v-if="certifInfo.extend">
          <div class="f-flex f-flex-betweent f-flex-rowcenter">
            <div style="position: relative">
              <img v-if="certifInfo.extend.groupFlag === '1'" src="../../../static/images/v26/tuan.png"
                   @click="tuanVisible = true"/>
              <img v-else src="../../../static/images/usericon_1.png"/>
              <f-model :visible.sync="tuanVisible" :showclose="false" width="380px" top="32vh">
                <div class="v26" slot="body">
                  <div class="aclose" @click="tuanVisible = false"
                       style="cursor: pointer;position: absolute;right: -29px;top: -41px;">
                    <i class="iconfont icon-fanbaiquxiao" style="font-size: 32px;color: #4D4D4D;"></i>
                  </div>
                  <div class="row">
                    <span>团体代号  &nbsp;&nbsp;&nbsp;&nbsp;  {{certifInfo.extend.appId}}</span>
                    <span style="color: #623cea;cursor: pointer;" @click="handleCopy(certifInfo.extend.appId)">复制</span>
                  </div>
                  <div class="row">
                    <span>团体密钥  &nbsp;&nbsp;&nbsp;&nbsp;  {{certifInfo.extend.appSecret}}</span>
                    <div>
                      <span style="color: #623cea; cursor: pointer;" @click="handleRefresh(certifInfo.extend.userId)">刷新</span>
                      <span style="color: #623cea; padding: 0 2px;">|</span>
                      <span style="color: #623cea; cursor: pointer;" @click="handleCopy(certifInfo.extend.appSecret)">复制</span>
                    </div>

                  </div>
                  <div class="row">
                    <span>有效日期  &nbsp;&nbsp;&nbsp;&nbsp;  {{ certifInfo.extend.startTime.replace(' 00:00:00', '') }} 至 {{ certifInfo.extend.endTime.replace(' 00:00:00', '') }}</span>
                  </div>
                  <div class="row" style="justify-content: center;">
                    <div class="btn" @click="handleOpen">
                      前往团体上传入口
                    </div>
                  </div>
                </div>
              </f-model>


              <!-- 已认证 -->
              <span
                  class="yrz">{{ userInfo.realFlag === '2' ? '已驳回' : userInfo.realFlag === '3' ? '审核中' : '已认证' }}</span>
            </div>
            <div class="v25-name">
              <p class="companyname text-sl">{{ certifInfo.extend.name }}</p>
              <div class="title">
                <span class="text">{{ certifInfo.extend.type == 1 ? "身份证" : "信用代码" }}</span>
                <span class="number">{{ certifInfo.extend.userCode }}</span>
              </div>
            </div>
            <img class="pinter img" @click="dowloadCertifi" src="../../../static/images/yyzzbtn.png"/>
          </div>
          <!--          <div class="f-flex f-flex-center info-number">-->
          <!--            <div class="f-flex-1 number-box">-->
          <!--              <span class="">{{-->
          <!--                certifInfo.extend.type == 1 ? "身份证" : "信用代码"-->
          <!--              }}</span>-->
          <!--              <p>{{ certifInfo.extend.userCode }}</p>-->
          <!--            </div>-->
          <!--            <div class="f-flex-1 number-box">-->
          <!--              <span class="">密保手机</span>-->
          <!--              <p>{{ certifInfo.extend.phone }}</p>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="balance-content">-->
          <!--            <div class="balance-title">账户余额（元）</div>-->
          <!--            <div class="balance">{{getFormatMoney(balance.balance)}}</div>-->
          <!--            <div class="balance-title">冻结余额（元）</div>-->
          <!--            <div class="balance">{{getFormatMoney(balance.frozenBalance)}}</div>-->
          <!--            <router-link to="/issue" ag="a" target="_blank" class="goup pinter">-->
          <!--              <div class="balance-image">-->
          <!--                充值+-->
          <!--              </div>-->
          <!--            </router-link>-->
          <!--          </div>-->
        </div>
        <div class="header">
          <div class="tab-content">
            <div class="tab-item pinter" :class="{'active': active === 0}" @click="handleTabClick(0)">套餐信息</div>
            <div class="tab-item pinter" :class="{'active': active === 1}" @click="handleTabClick(1)">账单信息</div>
            <div class="tab-item pinter" :class="{'active': active === 2}" @click="handleTabClick(2)">发票中心</div>
          </div>
        </div>
        <!--    套餐信息    -->
        <div v-if="active === 0 && licenseList.length > 0" class="info-licnse" style="min-height: 460px;">
          <div class="licnse-info">
            <span class="select-license pinter">
              <el-popover placement="bottom" width="80" popper-class="license-popper" :visible-arrow="false" :offset="0"
                          trigger="hover">
                <div class="item-content pinter">
                  <div class="item" :class="{'item-active': currentIndex === index}"
                       v-for="(item, index) in licenseList" :key="index" @click="handleChangeLicense(item, index)">
                    {{ item.licnse.name }}
                  </div>
                  <div v-if="licenseList.length === 0">
                    <el-empty :image-size="40" description="暂无数据"></el-empty>
                  </div>
                </div>
                <div slot="reference">
                  <span class="number">{{ licenseList.length }}</span> 个可用套餐 <span class="jiao"><i
                    class="el-icon-caret-right"></i></span>
                </div>
              </el-popover>
            </span>
            <p class="name">
              <span>{{ license.licnse.name }}
                <router-link tag="a" target="_blank" class="goup pinter" :to="{ path: '/issue' }">
                  去扩容
                </router-link>
              </span>
            </p>
            <span class="time">
              有效期 {{ license.startDate }} - {{ license.endDate }}
            </span>
          </div>
          <div class="licnse-detail">
            <div class="f-flex" style="flex-wrap: wrap; justify-content: space-between">
              <div class="detail-info-item" v-for="(item) in license.autoOption" :key="item.id">
                <!-- 1 哈希哦备案 autoRecordCount autoRecordUseCount  2  公证书 autoCertificateCount autoCertificateUseCount -->
                <div class="f-flex f-flex-betweent f-flex-rowcenter info-sx">
                  <span class="name">{{ item.autoLabel }}</span>
                  <span class="tips">
                    剩余
                    <i>{{ getLicenseCount(item) }}</i>
                    {{ item.autoUnit }}
                  </span>
                </div>
                <el-progress :show-text="false" :percentage="getLicensePercentage(item)"
                             v-if="!isNaN(getLicensePercentage(item))"/>
              </div>
              <div class="detail-info-item" v-for="(item) in license.manualOption" :key="item.id">
                <!-- 1 哈希哦备案 autoRecordCount autoRecordUseCount  2  公证书 autoCertificateCount autoCertificateUseCount -->
                <div class="f-flex f-flex-betweent f-flex-rowcenter info-sx">
                  <span class="name">{{ item.autoLabel }}</span>
                  <span class="tips">
                    剩余
                    <i :class="{ red: item.autoValue - item.allowance <= 0 }">
                      {{ (item.autoValue - (item.allowance || 0)) | useBigdDeafult }}
                    </i>
                    {{ item.autoUnit }}
                  </span>
                </div>
                <el-progress :show-text="false"
                             :percentage="parseInt(((item.allowance || 0) / (item.autoValue || 0)) * 100)"/>
              </div>
            </div>
          </div>
        </div>
        <!--    消费明细    -->
        <div v-if="active === 1" class="consume">
          <div class="table" v-if="consumeList.length > 0">
            <div class="table-item" v-for="(item, index) in consumeList" :key="index">
              <div class="table-header">
                <div class="header-text">创建时间：{{ item.createTime }}</div>
                <div class="header-text">订单号：{{ 'FACS' + item.id }}</div>
                <div class="header-text">
                  开票金额：{{ item.invoiceStatus !== '0' ? getFormatMoney(item.invoiceAmount) : '0.00' }}
                </div>
              </div>
              <div class="table-content">
                <div class="content-text">
                  <div style="display: flex;flex-direction: column;">
                    <div
                        style="color: #262626;font-size: 14px;width: 137px; overflow: hidden; text-overflow: ellipsis;">
                      {{ item.name }}
                    </div>
                    <div style="font-size: 12px;color: #737373;">
                      {{
                        item.service === '1' ? '哈希备案' : item.service === '2' ?
                            '公证证书' : item.service === '3' ? '侵权鉴定书' : '购买套餐'
                      }} <span style="margin-left: 20px;">x1</span>
                    </div>
                  </div>
                </div>
                <div class="content-text">
                  {{ item.consumeRemark === '1' ? '购买套餐' : item.consumeRemark === '2' ? '账户扣减' : '套餐扣减' }}
                </div>
                <div class="content-text">
                  <div :style="{ color: item.status === '0' ? '#eff0f4' : item.status === '1' ? '#2f934d' : item.status === '2' ?
                      '#EE0000' :  item.status === '3' ? 'EE0000' : '#4949dc'}">{{
                      item.status === '0' ? '待审核' : item.status === '1' ? '已通过' : item.status === '2' ?
                          '已驳回' : item.status === '3' ? '已终止' : '审核中'
                    }}
                  </div>
                  <div style="font-size: 12px;color: #737373;">
                    {{ item.invoiceStatus === '3' ? '待开票' : item.invoiceStatus === '2' ? '开票完成' : item.invoiceStatus === '1' ? '开票中' : '不可开票' }}
                  </div>
                </div>
                <div class="content-text" style="width: 100px;">
                  <div>金额</div>
                  <div style="font-size: 12px;color: #737373;">
                    {{ getFormatMoney(item.amount) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else style="text-align: center;">
            <el-empty :image-size="240" description="暂无数据"></el-empty>
          </div>
          <div class="page">
            <div class="pre pinter" @click="handlePre">
              <i class="el-icon-arrow-left "></i>
            </div>
            <div class="number">
              {{ page.current }}/{{ page.pages }}
            </div>
            <div class="next pinter" @click="handleNext">
              <i class="el-icon-arrow-right"></i>
            </div>
            <el-select size="mini" v-model="page.size" placeholder="页码" @change="handleSizeChange"
                       style="margin-left: 8px; width: 100px;">
              <el-option v-for="item in pageSize" :key="item" :label="item + '条/页'" :value="item"/>
            </el-select>
          </div>
        </div>
        <!--    发票中心    -->
        <div v-if="active === 2" class="invoice">
          <!--     发票信息、开票记录     -->
          <div v-if="invoiceActive === 0">
            <div class="info">
              <div style="color: #ee0000;margin-right: 4px;">
                <i class="el-icon-warning"></i>
              </div>
              <div>
                <div class="text">
                  1，账户充值金额不等于开票金额，开票仅针对已消费金额。账单明细中状态为已完成的账单方为可开票金额。
                </div>
                <div class="text">2，套餐购买成功后，整个套餐即可开具全额发票。</div>
              </div>
            </div>
            <div class="invoice-info">
              <div class="item-info">
                <div class="title">
                  可开票金额
                </div>
                <div class="content">
                  <span style="font-size: 14px;color: #4d4d4d;margin-bottom: -8px;margin-right: 2px;">￥</span>
                  <span style="font-size: 28px; color: #8674FC;font-weight: 900;">
                  {{ getFormatMoney(invoiceAmount) }}
                </span>
                  <div class="btn pinter" @click="handleDemandInvoice(1)">索取发票</div>
                </div>
              </div>
              <div class="item-info">
                <div class="title" style="padding: 0;">
                  发票信息
                  <span style="font-size: 12px; color: #999; margin-left: 30px;">发票信息与实名信息一致</span>
                </div>
                <div class="title" style="padding: 2px 0;margin-top: 4px;font-size: 14px;">
                  抬头
                  <span style="font-size: 14px; color: #4d4d4d; margin-left: 66px;">{{ certifInfo.extend.name }}</span>
                </div>
                <div class="title" style="padding: 2px 0;font-size: 14px;">
                  发票类型
                  <span style="font-size: 14px; color: #4d4d4d; margin-left: 37px;">增值税普通发票</span>
                </div>
              </div>
            </div>
            <div class="title">
              开票记录
            </div>
            <div class="table">
              <div class="table-header">
                <div class="header-text">申请时间</div>
                <div class="header-text">发票金额（￥）</div>
                <div class="header-text">发票介质</div>
                <div class="header-text">状态</div>
                <div class="header-text">操作</div>
              </div>
              <div v-if="invoiceList.length > 0">
                <div class="table-item" v-for="(item, index) in invoiceList" :key="index">
                  <div class="item-text">
                    {{ item.createTimeStr }}
                  </div>
                  <div class="item-text">
                    {{ getFormatMoney(item.invoiceAmount) }}
                  </div>
                  <div class="item-text">
                    电子发票
                  </div>
                  <div class="item-text">
                    {{
                      item.invoiceStatus === '1' || item.invoiceStatus === '2' ? '开票中' : item.invoiceStatus === '3' ? '开票完成' : '开票失败'
                    }}
                  </div>
                  <div class="item-text pinter">
                    <span style="color: #262626;" @click="handleDetail(item)">详情</span> |
                    <span v-if="item.invoiceStatus === '1' || item.invoiceStatus === '2'" style="color: #c3c3c3;">
                      发票预览与下载
                    </span>
                    <span v-else style="color: #262626;" @click="handlePreview(item)">发票预览与下载</span>
                  </div>
                </div>
              </div>
              <div v-else style="text-align: center;">
                <el-empty :image-size="60" description="暂无数据"></el-empty>
              </div>
              <l-model :visible.sync="invoiceListVisible" :showclose="true">
                <div class="i-list" slot="body">
                  <div class="i-header">
                    <div style="width: 160px;">
                      发票编号
                    </div>
                    <div style="width: 120px;">
                      操作
                    </div>
                  </div>
                  <div class="i-content">
                    <div class="i-item" v-for="(item, index) in invoicePDFList" :key="index">
                      <div style="width: 160px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                        {{ item.invoiceNo }}
                      </div>
                      <div style="width: 120px;">
                        <span @click="handleDownload(item)" class="pinter">下载</span> | <span class="pinter"
                                                                                               @click="previewVisible = !previewVisible">预览</span>
                      </div>
                    </div>
                  </div>
                </div>
              </l-model>
              <p-model :visible.sync="previewVisible" :showclose="true" width="971px">
                <div class="c-preview" slot="body">
                </div>
              </p-model>
            </div>
            <div class="page">
              <div class="pre pinter" @click="handlePre">
                <i class="el-icon-arrow-left "></i>
              </div>
              <div class="number">
                {{ page.current }}/{{ page.pages }}
              </div>
              <div class="next pinter" @click="handleNext">
                <i class="el-icon-arrow-right"></i>
              </div>
              <el-select size="mini" v-model="page.size" placeholder="页码" @change="handleSizeChange"
                         style="margin-left: 8px; width: 100px;">
                <el-option v-for="item in pageSize" :key="item" :label="item + '条/页'" :value="item"/>
              </el-select>
            </div>
          </div>
          <!--     索取发票     -->
          <div v-if="invoiceActive === 1" class="center">
            <div class="c-header">
              <span class="text">索取发票</span>
              <span class="c-btn pinter" @click="handleInvoiceGoCenter()">
                <i class="el-icon-arrow-left"/>
                <span>发票中心</span>
              </span>
            </div>
            <div class="c-step c-step-1" v-if="stepActive === 0"/>
            <div class="c-step c-step-2" v-if="stepActive === 1"/>
            <div class="c-step c-step-3" v-if="stepActive === 2"/>
            <!--      消费数据选择      -->
            <div v-if="stepActive === 0">
              <el-table ref="multipleTable" @selection-change="handleSelectionChange" :data="invoiceWaitList"
                        tooltip-effect="dark" style="width: 100%; margin-top: 8px;">
                <el-table-column type="selection" width="42">
                </el-table-column>
                <el-table-column prop="id" label="订单号">
                  <template #default="scope">{{ "FACS" + scope.row.id }}</template>
                </el-table-column>
                <el-table-column prop="consumeRemark" label="服务类型" width="95">
                  <template #default="{row}">
                    {{ row.consumeRemark === '1' ? '购买套餐' : row.consumeRemark === '2' ? '账号扣减' : '套餐扣减' }}
                  </template>
                </el-table-column>
                <el-table-column prop="service" label="服务内容" width="100">
                  <template #default="{row}">
                    {{ row.service === '1' ? '哈希备案' : row.service === '2' ? '公证证书' : row.service === '3' ? '侵权证书' : '购买套餐' }}
                  </template>
                </el-table-column>
                <el-table-column prop="createTimeStr" label="消费时间" width="135">
                </el-table-column>
                <el-table-column prop="invoiceAmount" label="可开票金额(元)" width="100">
                  <template #default="{row}">{{ getFormatMoney(row.invoiceAmount) }}</template>
                </el-table-column>
                <template #empty>
                  <el-empty :image-size="60" description="暂无数据"></el-empty>
                </template>
              </el-table>
              <div class="page" style="border-top: none;">
                <div class="pre pinter" @click="handlePre">
                  <i class="el-icon-arrow-left "></i>
                </div>
                <div class="number">
                  {{ page.current }}/{{ page.pages }}
                </div>
                <div class="next pinter" @click="handleNext">
                  <i class="el-icon-arrow-right"></i>
                </div>
                <el-select size="mini" v-model="page.size" placeholder="页码" @change="handleSizeChange"
                           style="margin-left: 8px; width: 100px;">
                  <el-option v-for="item in pageSize" :key="item" :label="item + '条/页'" :value="item"/>
                </el-select>
              </div>
              <div class="c-balance">
                <div class="text">待开票金额</div>
                <div class="amount">￥{{ getFormatMoney(invoiceSelectAmount) }}</div>
                <div class="btn pinter" @click="handleInvoiceNext(1)">下一步</div>
              </div>
            </div>
            <!--      确认发票信息      -->
            <div v-if="stepActive === 1">
              <div class="c-info">
                <div class="c-info-title">
                  <div class="title">发票信息</div>
                  <div class="sub-title">发票信息与实名信息一致</div>
                </div>
                <div class="c-info-content">
                  <div class="content-1">
                    <div class="content-row">
                      <div class="title">
                        抬头
                      </div>
                      <div class="content">
                        {{ userInfo.name }}
                      </div>
                    </div>
                    <div class="content-row">
                      <div class="title">
                        发票类型
                      </div>
                      <div class="content">
                        增值税普通发票
                      </div>
                    </div>
                  </div>
                  <div class="content-2">
                    <div class="content-row">
                      <div class="title">
                        抬头类型
                      </div>
                      <div class="content">
                        {{ certifInfo.extend.type == 1 ? '个人' : '企业' }}
                      </div>
                    </div>
                    <div class="content-row">
                      <div class="title">
                        发票介质
                      </div>
                      <div class="content">
                        电子发票
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-balance" style="margin-top: 29px;">
                <div class="text">待开票金额</div>
                <div class="amount">￥{{ getFormatMoney(invoiceSelectAmount) }}</div>
                <div class="pre-btn pinter" @click="handleInvoicePre(0)">上一步</div>
                <div class="next-btn pinter" @click="handleInvoiceNext(2)">下一步</div>
              </div>
            </div>
            <!--      预览发票      -->
            <div v-if="stepActive === 2">
              <div class="preview">
                <div class="title">
                  <i class="el-icon-warning" style="color:  #EE0000;"></i>请认真核对发票信息是否有误，确认无误后可点击提交完成申请。
                </div>
                <div class="content">
                  <div class="image">
                    <div class="search pinter" @click="handlePrePdf"></div>
                  </div>
                </div>
                <p-model :visible.sync="previewVisible" :showclose="true" width="971px">
                  <div class="c-preview" slot="body">
                    <img :src="previewUrl" height="434px" width="971px" alt="">
                  </div>
                </p-model>
              </div>
              <div class="c-balance" style="margin-top: 9px;">
                <div class="text">待开票金额</div>
                <div class="amount">￥{{ getFormatMoney(invoiceSelectAmount) }}</div>
                <div class="pre-btn pinter" @click="handleInvoicePre(1)">上一步</div>
                <div class="next-btn pinter" @click="handleInvoiceNext(3)">提交</div>
              </div>
            </div>
            <!--      申请成功      -->
            <div v-if="stepActive === 3">
              <div class="success">
                <div class="title">
                  恭喜您，发票申请成功！
                </div>
                <div class="btn pinter" @click="handleInvoiceGoCenter()">返回发票中心</div>
              </div>
            </div>
          </div>
          <!--     开票记录按钮     -->
          <div v-if="invoiceActive === 2">
            <!--     开票详情     -->
            <div v-if="detailActive === 0">
              <div class="detail">
                <div class="d-header">
                  <span style="color: #4D4D4D;font-size: 14px;">发票详情</span>
                  <div class="pinter d-btn" @click="handleInvoiceGoCenter()">
                    <i class="el-icon-arrow-left"/>
                    <span>发票中心</span>
                  </div>
                </div>
                <div class="d-title">发票组号：{{ 'FAIV' + currentInvoice.id }}</div>
                <div class="d-wait" v-if="currentInvoice.invoiceStatus === '1' || currentInvoice.invoiceStatus === '2'">
                  <div class="i-wait">
                    <span style="margin-top: -12px">...</span>
                  </div>
                  <span class="d-text" style="margin-left: 8px;">开票中</span>
                  <span class="d-text" style="margin-left: 18px">发票金额</span>
                  <span class="d-text"
                        style="color: #EE0000;margin-left: 8px;">￥{{ getFormatMoney(currentInvoice.invoiceAmount) }}</span>
                  <div class="d-wait-btn pinter" style="margin-left: 122px;padding: 0 6px;">
                    发票下载与预览
                  </div>
                </div>
                <div v-else class="d-success">
                  <div class="i-success"></div>
                  <span class="d-text" style="margin-left: 8px;">开票完成</span>
                  <span class="d-text" style="margin-left: 18px">发票金额</span>
                  <span class="d-text"
                        style="color: #EE0000;margin-left: 8px;">￥{{ getFormatMoney(currentInvoice.invoiceAmount) }}</span>
                  <div class="d-success-btn2 pinter" style="margin-left: 122px;color: #737373; padding: 0 6px;"
                       @click="handlePreview(currentInvoice)">
                    发票下载与预览
                  </div>
                </div>
                <div class="d-text" style="margin: 8px 0;">开票内容</div>
                <div class="d-table">
                  <div class="d-table-header">
                    <div style="width: 180px;">订单号</div>
                    <div style="width: 100px;">服务类型</div>
                    <div style="width: 140px;">服务内容</div>
                    <div style="width: 160px;">消费时间</div>
                    <div style="width: 90px;">可开票金额(元)</div>
                  </div>
                  <div class="d-table-content">
                    <div class="d-table-item" v-for="(item, index) in detailList" :key="index">
                      <div style="width: 180px;">{{ 'FACS' + item.consumeId }}</div>
                      <div style="width: 100px;">
                        {{ item.consumeRemark === '1' ? '购买套餐' : item.consumeRemark === '2' ? '账号扣减' : '套餐扣减' }}
                      </div>
                      <div style="width: 140px;">
                        {{ item.service === '1' ? '哈希备案' : item.service === '2' ? '公证证书' : item.service === '2' ? '侵权证书' : '购买套餐' }}
                      </div>
                      <div style="width: 160px;">{{ item.createTimeStr }}</div>
                      <div style="width: 90px;color: #FD9067;">{{ getFormatMoney(item.invoiceAmount) }}</div>
                    </div>
                  </div>
                </div>
                <div class="page" style="border-top: none;">
                  <div class="pre pinter" @click="handlePre">
                    <i class="el-icon-arrow-left "></i>
                  </div>
                  <div class="number">
                    {{ page.current }}/{{ page.pages }}
                  </div>
                  <div class="next pinter" @click="handleNext">
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <el-select size="mini" v-model="page.size" placeholder="页码" @change="handleSizeChange"
                             style="margin-left: 8px; width: 100px;">
                    <el-option v-for="item in pageSize" :key="item" :label="item + '条/页'" :value="item"/>
                  </el-select>
                </div>
              </div>
              <p-model :visible.sync="previewVisible" :showclose="true" width="971px">
                <div class="c-preview" slot="body">
                  <img :src="previewUrl" height="434px" width="971px" alt="">
                </div>
              </p-model>
              <l-model :visible.sync="invoiceListVisible" :showclose="true">
                <div class="i-list" slot="body">
                  <div class="i-header">
                    <div style="width: 160px;">
                      发票编号
                    </div>
                    <div style="width: 120px;">
                      操作
                    </div>
                  </div>
                  <div class="i-content">
                    <div class="i-item" v-for="(item, index) in invoicePDFList" :key="index">
                      <div style="width: 160px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                        {{ item.invoiceNo }}
                      </div>
                      <div style="width: 120px;">
                        <span class="pinter" @click="handleDownload(item)">下载</span> | <span class="pinter"
                                                                                               @click="handlePrePdf">预览</span>
                      </div>
                    </div>
                  </div>
                </div>
              </l-model>
            </div>
            <!--     发票预览     -->
            <div v-if="detailActive === 1">
              <p-model :visible.sync="previewVisible" :showclose="true" width="971px" @close="handlePreviewClose">
                <div class="c-preview" slot="body">
                </div>
              </p-model>
            </div>
          </div>
        </div>
        <div class="info-licnse" v-if="active === 0 && licenseList.length === 0">
          <div class="licnse-info">
            <span class="now">当前套餐</span>
            <p class="name">
              <span
              >您还未购买任何套餐<router-link
                  tag="a"
                  target="_blank"
                  class="goup pinter"
                  to="/issue"
              >去购买</router-link
              ></span
              >
            </p>
            <span class="time">有效期 20**/**/** - 20**/**/**</span>
          </div>
          <div class="licnse-detail">
            <div class="f-flex" style="flex-wrap: wrap; justify-content: space-between">
              <div
                  class="detail-info-item"
                  v-for="(item, index) in defaultList"
                  :key="index"
              >
                <!-- 1 哈希哦备案 autoRecordCount autoRecordUseCount  2  公证书 autoCertificateCount autoCertificateUseCount -->
                <div class="f-flex f-flex-betweent f-flex-rowcenter info-sx">
                  <span class="name">{{ item.autoLabel }}</span>
                  <span class="tips"
                  >剩余<i :class="{ red: item.autoValue == 0 }">{{
                      item.autoValue
                    }}</i
                  >{{ item.autoUnit }}</span
                  >
                </div>
                <el-progress
                    :show-text="false"
                    :percentage="parseInt(item.autoValue * 100)"
                ></el-progress>
              </div>
            </div>
          </div>
        </div>
        <div class="info-bottom" style="text-align: right">
          <span class="pw" @click="setPassword">修改密码</span>
          <span class="loginout" @click="loginout"> 退出登录</span>
        </div>
      </div>
    </f-model>
  </div>
</template>

<script>
import {userCertificateDownload} from '@/api';
import {DownloadByA} from '@/utils/Tools';
import {
  fetchApplyInvoice,
  fetchPDFPage, fetchRefresh,
  fetchUserBalance,
  fetchUserInvoiceAmount,
  fetchUserInvoiceDetail,
  fetchUserInvoiceList,
  fetchUserLicense,
  fetchUserWaitInvoiceList,
  getUserConsumeList,

} from '../../api';
import {formatMoney, isBlank} from '../../utils/Tools';
import pModel from '../pModel/index.vue';
import lModel from '../lModel/index.vue';

export default {
  components: {
    pModel,
    lModel
  },
  data() {
    return {
      visible: false,
      tuanVisible: false,
      defaultList: [
        {
          allowance: '10',
          autoLabel: '作品备案',
          autoType: '',
          autoUnit: '套',
          autoValue: '0'
        },
        {
          allowance: '',
          autoLabel: '电子公证书',
          autoType: '',
          autoUnit: '套',
          autoValue: '0'
        },
        {
          allowance: '10',
          autoLabel: '诉前咨询服务',
          autoType: '',
          autoUnit: '小时',
          autoValue: '0'
        },
        {
          allowance: '10',
          autoLabel: '行业专家鉴定书',
          autoType: '',
          autoUnit: '份',
          autoValue: '0'
        },
        {
          allowance: '10',
          autoLabel: '法律咨询',
          autoType: '',
          autoUnit: '小时',
          autoValue: '0'
        },
        {
          allowance: '10',
          autoLabel: '律师函',
          autoType: '',
          autoUnit: '份',
          autoValue: '0'
        },
        {
          allowance: '10',
          autoLabel: '合同拟定，审查',
          autoType: '',
          autoUnit: '份',
          autoValue: '0'
        },
        {
          allowance: '10',
          autoLabel: '上门法律服务',
          autoType: '',
          autoUnit: '小时',
          autoValue: '0'
        }
      ],
      licenseList: [], // 用户套餐列表
      balance: {}, // 用户余额
      active: 0, // tab active
      invoiceActive: 0, // 发票中心当前active
      stepActive: 0, // 索要发票-步骤条
      page: {
        total: 0, // 总页数
        current: 1, // 当前页数
        size: 4, // 每页显示多少条
        pages: 1
      },
      license: {}, // 当前切换的套餐
      consumeList: [], // 消费明细
      invoiceList: [], // 开票记录
      invoiceWaitList: [], // 待开票列表
      invoiceAmount: 0, // 待开票金额
      invoiceSelectAmount: 0, // 待开票金额
      pageSize: [4, 15, 30, 50, 100],
      previewVisible: false, // 预览发票
      invoiceListVisible: false, // 发票列表
      multipleSelection: [], // 待开数据
      detailActive: 0, // 发票详情 active
      currentInvoice: {}, // 当前开票单
      detailList: [], // 详情的列表
      invoicePDFList: [], // 发票附件列表
      currentIndex: 0, // 当前选择的套餐
      previewUrl: '',
      appSecret: ''
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || '';
    },
    certifInfo() {
      return this.$store.state.certifInfo;
    },
    getLicenseCount() {
      return function (val) {
        if (!isBlank(this.license)) {
          switch (val.autoType) {
            case '1':
              return this.license.autoRecordCount - this.license.autoRecordUseCount;
            case '2':
              return this.license.autoCertificateCount - this.license.autoCertificateUseCount;
            case '3':
              return this.license.expertsCount - this.license.expertsUseCount;
          }
        }
      };
    },
    getLicensePercentage() {
      return function (val) {
        if (!isBlank(this.license)) {
          switch (val.autoType) {
            case '1':
              return ((this.license.autoRecordUseCount / this.license.autoRecordCount) * 100) > 100 ? 100 : ((this.license.autoRecordUseCount / this.license.autoRecordCount) * 100);
            case '2':
              return ((this.license.autoCertificateUseCount / this.license.autoCertificateCount) * 100) > 100 ? 100 : ((this.license.autoCertificateUseCount / this.license.autoCertificateCount) * 100);
            case '3':
              return ((this.license.expertsUseCount / this.license.expertsCount) * 100) > 100 ? 100 : ((this.license.expertsUseCount / this.license.expertsCount) * 100);
          }
        }
      };
    },
    getFormatMoney: function () {
      return function (val) {
        return formatMoney(val);
      };
    }
  },
  methods: {
    // ====================================================【按钮方法】===================================================
    dowloadCertifi() {
      userCertificateDownload(this.userInfo.userId).then(res => {
        if (res.code === 0) {
          DownloadByA(res.data, '营业执照.jpg');
        }
      });
    },
    setPassword() {
      this.$store.commit('setResetVisible', true);
    },
    close() {
      this.visible = false;
    },
    loginout() {
      this.visible = false;
      this.$store.dispatch('loginOut').then(res => {
        this.$message.success('退出成功');
      });
    },
    // 处理Tab 切换
    handleTabClick(index) {
      this.active = index;
      if (index === 1) {
        this.page = {
          total: 0, // 总页数
          current: 1, // 当前页数
          size: 4, // 每页显示多少条
          pages: 1
        };
        this.pageSize = [4, 15, 30, 50, 100];
        this.handleGetUserConsumeList(this.page);
      } else if (index === 2) {
        // 发票中心
        if (this.invoiceActive === 0) {
          this.page = {
            total: 0, // 总页数
            current: 1, // 当前页数
            size: 3, // 每页显示多少条
            pages: 1
          };
          this.pageSize = [3, 15, 30, 50, 100];
          this.handleGetInvoiceList(this.page);
          this.handleWaitInvoiceAmount();
        }
      }
    },
    // 获取待开票金额
    handleWaitInvoiceAmount: function () {
      fetchUserInvoiceAmount(this.userInfo.userId).then(res => {
        this.invoiceAmount = res.data;
      });
    },
    // 处理套餐切换
    handleChangeLicense: function (item, index) {
      this.currentIndex = index;
      this.license = item;
      if (this.license) {
        if (typeof this.license.autoOption === 'string') {
          this.license.autoOption = JSON.parse(this.license.autoOption);
        }
        if (typeof this.license.manualOption === 'string') {
          this.license.manualOption = JSON.parse(this.license.manualOption);
        }
      }
    },
    // 上一页
    handlePre: function () {
      if (this.page.current !== 1) {
        this.page.current = this.page.current - 1;
      }
      if (this.active === 1) {
        // 消费记录
        this.handleGetUserConsumeList(this.page);
      } else if (this.active === 2) {
        if (this.invoiceActive === 0) {
          // 开票记录
          this.handleGetInvoiceList(this.page);
        } else if (this.invoiceActive === 1) {
          // 待开票记录
          this.handleGetUsesWaitInvoiceList(this.page);
        } else if (this.invoiceActive === 2) {
          if (this.detailActive === 0) {
            this.handleInvoiceDetailList(this.page);
          }
        }
      }
    },
    // 下一页
    handleNext: function () {
      if (this.page.current >= this.page.pages) {
        return false;
      }
      this.page.current = this.page.current + 1;
      if (this.active === 1) {
        // 消费记录
        this.handleGetUserConsumeList(this.page);
      } else if (this.active === 2) {
        if (this.invoiceActive === 0) {
          // 开票记录
          this.handleGetInvoiceList(this.page);
        } else if (this.invoiceActive === 1) {
          // 待开票记录
          this.handleGetUsesWaitInvoiceList(this.page);
        } else if (this.invoiceActive === 2) {
          if (this.detailActive === 0) {
            this.handleInvoiceDetailList(this.page);
          }
        }
      }
    },
    // 分页size change event
    handleSizeChange: function (val) {
      this.page = {
        total: 0, // 总页数
        current: 1, // 当前页数
        size: val, // 每页显示多少条
        pages: 1
      };
      if (this.active === 1) {
        // 消费记录
        this.handleGetUserConsumeList(this.page);
      } else if (this.active === 2) {
        if (this.invoiceActive === 0) {
          // 开票记录
          this.handleGetInvoiceList(this.page);
        } else if (this.invoiceActive === 1) {
          // 待开票记录
          this.handleGetUsesWaitInvoiceList(this.page);
        } else if (this.invoiceActive === 2) {
          if (this.detailActive === 0) {
            this.handleInvoiceDetailList(this.page);
          }
        }
      }
    },
    // 索要发票
    handleDemandInvoice: function (index) {
      this.invoiceActive = index;
      this.page = {
        total: 0, // 总页数
        current: 1, // 当前页数
        size: 5, // 每页显示多少条
        pages: 1
      };
      this.pageSize = [5, 15, 30, 50, 100];
      this.handleGetUsesWaitInvoiceList(this.page);
    },
    // 索要发票步骤切换 下一步
    handleInvoiceNext: function (index) {
      if (index === 3) {
        // 提交发票申请
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择消费数据申请开票');
          return false;
        } else {
          let data = {
            userId: this.userInfo.userId,
            consumedIds: this.multipleSelection.map(item => item.id)
          };
          fetchApplyInvoice(data).then(res => {
            this.stepActive = index;
          });
        }
      } else {
        this.stepActive = index;
      }
    },
    // 索要发票步骤切换 上一步
    handleInvoicePre: function (index) {
      this.stepActive = index;
      if (index === 0) {
        this.$nextTick(() => {
          this.multipleSelection.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        });
      }
    },
    // 多选的待开数据
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
      this.invoiceSelectAmount = this.multipleSelection.reduce((pre, cur) => {
        return pre + cur.amount;
      }, 0);
    },
    handlePrePdf: async function () {
      let _that = this;
      const bgImg = await this.loadImage('/static/images/v25/preview_invoice_big.png');
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 971;
      canvas.height = 434;
      ctx.font = '14px alibaba';
      ctx.fontVariant = 'normal';
      ctx.fillStyle = '#629bf4';
      ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height); // 背景图
      console.log(_that.certifInfo.extend.name);
      ctx.fillText(_that.certifInfo.extend.name, 160, 95);
      ctx.fillText(_that.certifInfo.extend.userCode, 160, 115);
      let dataUrl = canvas.toDataURL('image/jpeg', 0.3);
      console.log(dataUrl);
      _that.previewUrl = dataUrl;
      _that.previewVisible = true;
    },
    loadImage(_src) {
      return new Promise((resolve, reject) => {
        if (!_src) {
          resolve();
          return;
        }
        let img = new Image();
        img.src = (_src);
        img.onload = () => {
          resolve(img);
        };
      });
    },
    convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(',')[1]); // 去掉url的头，并转换为byte

      // 处理异常,将ascii码小于0的转换为大于0

      var ab = new ArrayBuffer(bytes.length);

      var ia = new Uint8Array(ab);

      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }

      return new Blob([ab], {

        type: 'image/jpg'

      });
    },
    // 开票记录-预览
    handlePreview: function (row) {
      fetchPDFPage({groupId: row.id}).then(res => {
        this.invoicePDFList = res.data;
        this.invoiceListVisible = true;
      });
    },
    // 开票记录-预览-关闭
    handlePreviewClose: function () {
      this.detailActive = 0;
      this.invoiceActive = 0;
    },
    // TODO 下载发票
    handleDownload: function (val) {
      let Adom = document.createElement('a');
      Adom.href = val.invoicePdf;
      let ext = val.invoicePdf.split('.')[1];
      Adom.download = new Date().getTime() + '.' + ext;
      document.body.appendChild(Adom);
      Adom.click();
      document.body.removeChild(Adom);
    },
    // 线上发票详情
    handleDetail: function (val) {
      this.currentInvoice = val;
      console.log('发票详情:::', val);
      this.detailActive = 0;
      this.invoiceActive = 2;
      this.page = {
        total: 0, // 总页数
        current: 1, // 当前页数
        size: 5, // 每页显示多少条
        pages: 1
      };
      this.pageSize = [5, 15, 30, 50, 100];
      this.handleInvoiceDetailList(this.page);
    },
    // 回到开票中心
    handleInvoiceGoCenter: function () {
      this.active = 2;
      this.invoiceActive = 0;
      this.stepActive = 0;
      // 发票中心
      if (this.invoiceActive === 0) {
        this.page = {
          total: 0, // 总页数
          current: 1, // 当前页数
          size: 3, // 每页显示多少条
          pages: 1
        };
        this.pageSize = [3, 15, 30, 50, 100];
        this.handleGetInvoiceList(this.page);
        this.handleWaitInvoiceAmount();
      }
    },
    // ====================================================【按钮方法】===================================================

    // ====================================================【接口方法】===================================================
    // 获取用户余额
    getUserBalance: function () {
      fetchUserBalance(this.userInfo.userId).then(res => {
        console.log('用户余额:::', res.data);
        this.balance = res.data;
      });
    },
    // 获取用户套餐列表
    getUserLicense: function () {
      fetchUserLicense(this.userInfo.userId).then(res => {
        console.log('用户套餐:::', res.data);
        this.licenseList = res.data;
        if (this.licenseList.length > 0) {
          this.license = this.licenseList[0];
          if (this.license) {
            this.license.autoOption = JSON.parse(this.license.autoOption);
            this.license.manualOption = JSON.parse(this.license.manualOption);
          }
          console.log('当前切换的用户套餐:::', this.license);
        }
      });
    },
    // 获取开票记录
    handleGetInvoiceList(page) {
      fetchUserInvoiceList(this.userInfo.userId, page).then(res => {
        this.page.total = res.data.total;
        this.page.current = res.data.current;
        this.page.pages = res.data.pages === 0 ? 1 : res.data.pages;
        this.invoiceList = res.data.records;
        console.log('开票记录:::', this.invoiceList);
      });
    },
    // 获取消费记录明细
    handleGetUserConsumeList: function (page) {
      getUserConsumeList(this.userInfo.userId, page).then(res => {
        console.log('用户账单列表:::', res.data);
        this.page.total = res.data.total;
        this.page.current = res.data.current;
        this.page.pages = res.data.pages === 0 ? 1 : res.data.pages;
        this.consumeList = res.data.records;
      });
    },
    // 获取待开发票列表
    handleGetUsesWaitInvoiceList: function (page) {
      fetchUserWaitInvoiceList(this.userInfo.userId, page).then(res => {
        this.page.total = res.data.total;
        this.page.current = res.data.current;
        this.page.pages = res.data.pages === 0 ? 1 : res.data.pages;
        this.invoiceWaitList = res.data.records;
        console.log('待开发票列表:::', this.invoiceWaitList);
      });
    },
    // 获取开票详情列表
    handleInvoiceDetailList: function (page) {
      fetchUserInvoiceDetail(this.currentInvoice.id, page).then(res => {
        this.page.total = res.data.total;
        this.page.current = res.data.current;
        this.page.pages = res.data.pages === 0 ? 1 : res.data.pages;
        this.detailList = res.data.records;
      });
    },
    // ====================================================【接口方法】===================================================
    handleOpen: function () {
      window.open('https://platform.fippc.org.cn/', '_blank');
    },
    handleCopy: function (text) {
      let inputDom = document.createElement('textarea') // js创建一个文本框
      document.body.appendChild(inputDom) //将文本框暂时创建到实例里面
      inputDom.value = text //将需要复制的内容赋值到创建的文本框中
      inputDom.select() //选中文本框中的内容
      inputDom.focus()
      document.execCommand('copy') //执行复制操作
      document.body.removeChild(inputDom) //最后移出
      this.$message.success('复制成功');
    },
    handleRefresh: function(userId) {
      fetchRefresh(userId).then(res => {
        this.appSecret = res.data;
      })
    }
  },
  watch: {
    visible: function (nval) {
      if (nval) {
        if (this.$store.state.userInfo !== '') {
          this.$store.dispatch('getUserCertifinfo');
        }
        this.getUserBalance();
        this.getUserLicense();
      }
    },
    appSecret: function (nval) {
      console.log(nval)
      if (nval) {
        if (this.$store.state.userInfo !== '') {
          this.$store.dispatch('getUserCertifinfo');
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v26 {
  height: 184px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 32px 8px 32px;

  background: #FFFFFF;

  /* 输入框外阴影 */
  box-shadow: 0px 0px 4px 0px #4590EF;

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    color: #4D4D4D;
    font-size: 12px;
    padding: 5px 0;
  }
  .btn {
    cursor: pointer;
    width: 112px;
    height: 28px;
    border-radius: 5px;
    background: #FD9067;
    color: #FFFFFF;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 18px;
  }
}

// 2.5 新增UI
.v25 {
  .v25-name {
    .title {
      display: flex;
      flex-direction: row;
      margin-top: 8px;

      .text {
        font-size: 14px;
        font-weight: normal;
        display: flex;
        align-items: center;
        color: #FFFFFF;
        background-color: #968fcd;
        border-radius: 5px;
        padding: 2px 4px;
      }

      .number {
        font-size: 14px;
        font-weight: normal;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
        margin-left: 15px;
      }
    }
  }

  .img {
    margin-top: -30px;
  }

  .balance-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    bottom: 10px;
    width: 592px;
    justify-content: space-between;

    .balance-title {
      color: #D1D1F6;
      font-size: 14px;
      font-weight: normal;
      min-width: 100px;
      margin-bottom: -6px;
    }

    .balance {
      font-size: 24px;
      font-weight: normal;
      color: #FFFFFF;
      width: 100%;
      text-align: left;
    }

    .balance-image {
      background: #EE0000;
      width: 100px;
      height: 32px;
      border-radius: 18px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #FFF;
    }
  }

  .header {
    background-color: #FFF;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    position: relative;
    padding-top: 24px;
    border-bottom: 1px #f5f4fc solid;
    padding-bottom: 2px;
  }

  .tab-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 430px;
    height: 32px;
    border-radius: 30px;
    background: #F2F2F2;
    margin: 0 auto;
    padding: 0 16px;

    .tab-item {
      color: #737373;
      width: 135px;
      font-size: 14px;
      border-radius: 30px;
      text-align: center;
      height: 32px;
      line-height: 32px;
    }

    .active {
      background: #8674FC;
      color: #FFF;
    }
  }

  .select-license {
    background: #6A4BEC;
    height: 28px;
    border-radius: 5px;
    top: 15px;
    left: 20px;
    position: absolute;
    line-height: 28px;
    color: #FFF;
    padding: 0 6px;
    font-size: 12px;

    .number {
      color: #FD9067;
      font-weight: 500;
    }

    .jiao {
      i {
        transform: rotateZ(40deg);
      }
    }

  }

  .consume {
    position: relative;
    background-color: #FFF;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    padding: 16px;
    height: 460px;

    .table {
      max-height: 392px;
      min-height: 392px;
      overflow-y: scroll;
    }

    .table-item {
      display: flex;
      flex-direction: column;
      width: 100%;

      .table-header {
        height: 42px;
        width: 100%;
        border-width: 1px 0px 0px 0px;
        border-style: solid;
        border-color: #D1D1F6;
        background: #F6F6FD;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: #737373;
        padding: 0 16px;

        .header-text {
          text-align: left;
        }
      }

      .table-content {
        display: flex;
        flex-direction: row;
        height: 56px;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;

        .content-text {
          font-size: 14px;
          color: #262626;
          text-align: left;
          display: flex;
          flex-direction: column;
        }
      }
    }
  }

  .invoice {
    position: relative;
    background-color: #FFF;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    padding: 16px;
    height: 460px;

    .info {
      width: 100%;
      background: #ECECFB;
      display: flex;
      flex-direction: row;
      padding: 16px 20px 20px 36px;

      .text {
        color: #3D3D3D;
        font-size: 12px;
      }
    }

    .invoice-info {
      margin-top: 8px;
      width: 100%;
      box-sizing: border-box;
      /* 颜色样式/中性色/灰阶6级 */
      border-width: 1px 1px 1px 1px;
      border-style: solid;
      border-color: #DEDEDE;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .item-info {
        flex: 1;
        height: 122px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .title {
          font-size: 16px;
          color: #4D4D4D;
          width: 100%;
          margin-left: 36px;
        }

        .content {
          display: flex;
          flex-direction: row;
          margin-top: 0px;
          align-items: center;
          margin-left: 36px;

          .btn {
            width: 100px;
            height: 32px;
            background: #EE0000;
            border-radius: 16px;
            font-size: 16px;
            line-height: 32px;
            text-align: center;
            color: #FFFFFF;
            margin-left: 24px;
          }
        }
      }

      .item-info:first-child {
        border-right: 1px #dedede solid;
      }
    }

    .title {
      color: #4D4D4D;
      font-size: 16px;
      padding: 8px 0;
    }

    .table {
      width: 100%;
      max-height: 152px;
      min-height: 152px;
      overflow-y: scroll;

      .table-header {
        background: #F2F2F2;
        box-sizing: border-box;
        /* 颜色样式/主色色阶/蓝阶6级 */
        border-width: 0px 0px 1px 0px;
        border-style: solid;
        border-color: #ECECFB;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px 16px;
        height: 32px;

        .header-text {
          flex: 1;
          text-align: left;
        }
      }

      .table-item {
        display: flex;
        flex-direction: row;
        height: 40px;
        font-size: 12px;
        color: #262626;
        padding: 0px 16px;
        border-width: 0px 0px 1px 0px;
        border-style: solid;
        border-color: #DEDEDE;

        .item-text {
          flex: 1;
          line-height: 40px;
          text-align: left;
        }
      }

      .table-item:last-child {
        border: none;
      }
    }
  }

  .center {
    display: flex;
    flex-direction: column;

    .c-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 8px;

      .text {
        font-size: 14px;
        color: #4D4D4D;
      }

      .c-btn {
        background: #F6F6FD;
        border: 1px solid #D1D1F6;
        width: 88px;
        height: 24px;
        border-radius: 30px;
        line-height: 24px;
        text-align: center;
        font-size: 12px;
        color: #623CEA;
        margin-left: 16px;
      }
    }

    .c-step {
      width: 688px;
      height: 48px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      border: 1px #c6c4c4 dashed;
    }

    .c-step-1 {
      background: url("../../../static/images/v25/step_1.png");
    }

    .c-step-2 {
      background: url("../../../static/images/v25/step_2.png");
    }

    .c-step-3 {
      background: url("../../../static/images/v25/step_3.png");
    }

    .c-title {
      margin: 8px 0;
      border: 1px solid #BFBFBF;
      width: 64px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      color: #4D4D4D;
    }

    .c-balance {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 8px;

      .text {
        font-size: 12px;
        color: #737373;
        margin-left: 210px;
        margin-bottom: -6px;
      }

      .amount {
        font-size: 24px;
        color: #EE0000;
        font-weight: 900;
        margin-left: 8px;
      }

      .pre-btn {
        width: 100px;
        height: 24px;
        border-radius: 5px;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        margin-left: 24px;
        border: 1px solid #BFBFBF;
        color: #737373;
      }

      .next-btn {
        width: 100px;
        height: 24px;
        border-radius: 5px;
        background: #EE0000;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 24px;
        text-align: center;
        margin-left: 8px;
      }

      .btn {
        width: 100px;
        height: 24px;
        border-radius: 5px;
        background: #EE0000;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 24px;
        text-align: center;
        margin-left: 132px;
      }
    }

    .c-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 24px 0px;
      gap: 24px;
      width: 688px;
      height: 264px;
      background: #FFFFFF;

      .c-info-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .title {
          font-size: 16px;
          color: #4949DC;
        }

        .sub-title {
          font-size: 12px;
          color: #9B9BEC;
          margin-left: 30px;
        }
      }

      .c-info-content {
        display: flex;
        flex-direction: row;

        .content-1 {
          width: 344px;
          height: 120px;
          border-width: 1px 0px 1px 1px;
          border-style: solid;
          border-color: #DEDEDE;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 34px;
        }

        .content-2 {
          width: 344px;
          height: 120px;
          border-width: 1px 1px 1px 0px;
          border-style: solid;
          border-color: #DEDEDE;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 34px;
        }

        .content-row {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;

          .title {
            font-size: 14px;
            color: #999999;
            width: 56px;
            text-align: left;
          }

          .content {
            font-size: 14px;
            text-align: left;
            color: #4D4D4D;
            margin-left: 38px;
            max-height: 182px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .preview {
      display: flex;
      flex-direction: column;

      .title {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 688px;
        height: 32px;
        border-radius: 10px;
        background: #EEF0FD;
        color: #3D3D3D;
        font-size: 12px;
        margin-top: 8px;
      }

      .content {
        width: 688px;
        height: 244px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .image {
          width: 503px;
          height: 225px;
          background: url('../../../static/images/v25/preview_invoice.png');
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;

          .search {
            background: #262626;
            width: 40px;
            height: 40px;
            background: url('../../../static/images/v25/search.png');
          }
        }
      }
    }

    .success {
      width: 688px;
      height: 264px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 128px;

      .title {
        margin-top: 43px;
        width: 688px;
        line-height: 120px;
        text-align: center;
        border: 1px solid #D1D1F6;
        font-size: 28px;
        color: #EE0000;
      }

      .btn {
        background: #8674FC;
        margin-top: 16px;
        margin-left: 144px;
        margin-right: 144px;
        width: 400px;
        height: 42px;
        border-radius: 30px;
        font-size: 20px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
        margin-bottom: 43px;
      }
    }
  }

  .detail {
    display: flex;
    flex-direction: column;

    .d-header {
      display: flex;
      flex-direction: row;
      align-items: center;

      .d-btn {
        width: 88px;
        height: 24px;
        border-radius: 30px;
        line-height: 24px;
        text-align: center;
        background: #F6F6FD;
        box-sizing: border-box;
        /* 颜色样式/主色色阶/蓝阶5级 */
        border: 1px solid #D1D1F6;
        font-size: 12px;
        color: #623CEA;
        margin-left: 16px;
      }
    }

    .d-title {
      color: #4D4D4D;
      font-size: 12px;
      margin: 8px 0;
    }

    .d-wait {
      width: 688px;
      height: 72px;
      background: #F1FFF6;
      box-sizing: border-box;
      border: 1px solid #AFD6BD;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      .i-wait {
        width: 48px;
        height: 48px;
        background: #D8D8D8;
        border-radius: 24px;
        color: #FFFFFF;
        font-size: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }

      .d-wait-btn {
        width: 120px;
        height: 24px;
        border-radius: 5px;
        background: #F2F2F2;
        box-sizing: border-box;
        border: 1px solid #BFBFBF;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
        color: #BFBFBF;
      }
    }

    .d-success {
      width: 688px;
      height: 72px;
      background: #F1FFF6;
      box-sizing: border-box;
      border: 1px solid #AFD6BD;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      .i-success {
        width: 48px;
        height: 48px;
        background: url("../../../static/images/v25/i_success.png");
      }

      .d-success-btn {
        width: 120px;
        height: 24px;
        border-radius: 5px;
        background: #F2F2F2;
        box-sizing: border-box;
        border: 1px solid #BFBFBF;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
      }

      .d-success-btn2 {
        width: 120px;
        height: 24px;
        border-radius: 5px;
        background: #2F934D;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
        color: #FFFFFF !important;
      }
    }

    .d-text {
      color: #4D4D4D;
      font-size: 16px;
    }

    .d-table {
      display: flex;
      flex-direction: column;

      .d-table-header {
        display: flex;
        flex-direction: row;
        padding: 0 16px;
        height: 32px;
        align-items: center;
        box-sizing: border-box;
        background: #F2F2F2;
        border-width: 0px 0px 1px 0px;
        border-style: solid;
        border-color: #ECECFB;
        color: #737373;
        font-size: 12px;
        text-align: left;
      }

      .d-table-content {
        min-height: 192px;
        max-height: 232px;
        overflow-y: scroll;

        .d-table-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          background: #FFFFFF;
          box-sizing: border-box;
          padding: 0px 16px;
          border-width: 0px 0px 1px 0px;
          border-style: solid;
          border-color: #DEDEDE;
          line-height: 40px;
          height: 40px;
          font-size: 12px;
          color: #262626;
        }
      }
    }
  }

  .page {
    height: 44px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    border-top: 1px #d1d1f6 solid;
    padding-right: 44px;

    .pre {
      background: #F2F2F2;
      border-radius: 2px;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
    }

    .next {
      background: #F2F2F2;
      border-radius: 2px;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
    }

    .number {
      color: #737373;
      font-size: 12px;
      text-align: center;
      margin: 0 18px;
    }
  }
}

.i-list {
  width: 352px;
  height: 304px;
  border-radius: 20px;
  padding: 16px;
  background: #FFF;
  margin-left: 45px;

  .i-header {
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #ECECFB;
    height: 32px;
    line-height: 32px;
    background: #F2F2F2;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #737373;
    font-size: 12px;
    padding: 0 16px;
  }

  .i-content {
    max-height: 240px;
    overflow-y: scroll;

    .i-item {
      padding: 0 16px;
      color: #262626;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      border-width: 0px 0px 1px 0px;
      border-style: solid;
      border-color: #F2F2F2;
    }
  }
}
</style>
<style lang="scss">
.license-popper {
  margin-top: 0px !important;
  border-radius: 5px;
  min-width: 104px !important;

  .item-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .item {
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 78px;
      margin-bottom: 10px;
      height: 20px;
      line-height: 20px;
      padding: 0 4px;
    }

    .item:last-child {
      margin-bottom: 0px;
    }

    .item-active {
      background: #F2F2F2;
      border-radius: 5px;
    }
  }
}

.center {
  .el-table__header-wrapper th.el-table__cell.is-leaf {
    border-bottom: none;
  }

  .el-table th.el-table__cell {
    background: #F2F2F2;
  }

  .el-table__header-wrapper .el-table__header tr .el-table-column--selection .cell {
    padding-left: 14px !important;
    font-size: 12px;
  }

  .el-table__header-wrapper .el-table__header tr .cell {
    font-size: 12px;
    color: #737373;
    padding-left: 4px;
    padding-right: 4px;
  }

  .el-table__body-wrapper .el-table__row {
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #DEDEDE;
  }

  .el-table__header-wrapper .el-table__cell {
    padding: 5px 0;
  }

  .el-table__body-wrapper .el-table__row .el-table__cell {
    padding: 8px 0;

    .cell {
      font-size: 12px;
      color: #262626;
      padding-left: 4px;
      padding-right: 4px;
    }
  }

  .el-table__body-wrapper .el-table__row .el-table-column--selection .cell {
    padding-left: 14px;
  }

  .el-table__body-wrapper {
    min-height: 200px;
    overflow-y: scroll;
    max-height: 200px;
  }
}

.page {
  .el-input__inner {
    border: 1px #FFF solid !important;
    background: #F2F2F2;
  }

  .el-input {
    border: 1px #FFF solid !important;
    background: #F2F2F2;
  }
}

.c-preview {
  width: 971px;
  height: 434px;
  // background: url('../../../static/images/v25/preview_invoice_big.png') no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/userinfo/index.vue